import { render, staticRenderFns } from "./bloodStore.vue?vue&type=template&id=efbc7cf2&scoped=true"
import script from "./bloodStore.vue?vue&type=script&lang=js"
export * from "./bloodStore.vue?vue&type=script&lang=js"
import style0 from "./bloodStore.vue?vue&type=style&index=0&id=efbc7cf2&prod&scoped=true&lang=css"
import style1 from "./bloodStore.vue?vue&type=style&index=1&id=efbc7cf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbc7cf2",
  null
  
)

export default component.exports